
import React, { useState } from 'react'
import { gql } from "@apollo/client"
import { useCurrentUser } from '../../redux/selectors'
import OptimizationTable from './OptimizationTable'
import PeriodGraph from './PeriodGraph'
import ReportsFilter from '../../components/ReportsFilter/ReportsFilter'
import { useLastStartedCompanyPeriod } from '../../redux/selectors'
import {Loading} from '../../components/Loading/Loading'
import { useTranslation } from 'react-i18next';

const OPTIMIZATION_QUERIES = gql`
  query($period:Period, $currency:String, $reportType:String){
    optimizationPeriodTotals(period:$period, currency:$currency, reportType:$reportType){
      lineCount
      cost
      date
    }
  }
`

const reports = [
  'zero_usage',
  'not_assigned',
  'assigned_to_terminated',
  'assigned_to_user_with_multiple',
  'assigned_to_inactive_site',
];

function Optimization({}) {
    const { t } = useTranslation();

    const currentUser = useCurrentUser();
    const LastCompanyPeriod = useLastStartedCompanyPeriod()

    const [currentReport, setcurrentReport] = useState(reports[0]);
    const [currency, setCurrency] = useState(
      {
        code:currentUser?.currency.code, 
        symbol:currentUser?.currency.symbol
      }
    )

    const [period, setPeriod] = useState({year: LastCompanyPeriod.year, month: LastCompanyPeriod.month})

    const handleChangeCurrency = (currencyCode, symbol) => {
      setCurrency({code:currencyCode, symbol:symbol})
    }

    const handleChangeDate = (year, month) => {
      setPeriod({year:year, month:month})
    }

    const generateFilters = () =>{
      const periodString = `${period.year}-${period.month}`
      return {period: periodString, currency:currency.code, reportType: currentReport}
    }

    const infoButtonData = {
      label: t("Lines with no usage and cost above cero")
    }

    const buttonsData = [
      {
          label: t("Zero Usage"),
          color: currentReport != 'zero_usage' ? "gray" : "#55758C",
          variant: currentReport != 'zero_usage' ? "outlined" : "contained",
          onClick: () => setcurrentReport('zero_usage'),
      },
      {
        label: t("Not assigned"),
        color: currentReport != 'not_assigned' ? "gray" : "#55758C",
        variant: currentReport != 'not_assigned' ? "outlined" : "contained",
        onClick: () => setcurrentReport('not_assigned'),
      },
      {
        label: t("Assigned to invalid"),
        color: currentReport != 'assigned_to_terminated' ? "gray" : "#55758C",
        variant: currentReport != 'assigned_to_terminated' ? "outlined" : "contained",
        onClick: () => setcurrentReport('assigned_to_terminated'),
      },
      {
        label: t("Multiple assigments"),
        color: currentReport != 'assigned_to_user_with_multiple' ? "gray" : "#55758C",
        variant: currentReport != 'assigned_to_user_with_multiple' ? "outlined" : "contained",
        onClick: () => setcurrentReport('assigned_to_user_with_multiple'),
      },
      {
        label: t("Inactive sites"),
        color: currentReport != 'assigned_to_inactive_site' ? "gray" : "#55758C",
        variant: currentReport != 'assigned_to_inactive_site' ? "outlined" : "contained",
        onClick: () => setcurrentReport('assigned_to_inactive_site'),
      },
  ]

    return (
      <>
        <ReportsFilter
          buttons={buttonsData}
          info={infoButtonData}
          date={period}
          onChangeDate={handleChangeDate}
          currencySelected={currency.code}
          onChangeCurrency={handleChangeCurrency}
        />
        <Loading query={OPTIMIZATION_QUERIES} variables={generateFilters()}>
          {(data)=>{
            return(
                <div>
                  <PeriodGraph currency={currency} data={data} t={t} className="mt-2 mb-2" />
                  <OptimizationTable title={"Optimization"} currency={currency} data={data} filters={generateFilters()} currentReport={currentReport}/>
                </div>
            )
          }}
        </Loading>
      </>
    )
}

export default Optimization;
